<template>
	<span :title="value">
		<el-tag v-if="option" effect="dark" size="mini"
			:type="option.color">{{option.en||option.zh||option.value||value}}</el-tag>
		<span v-else>{{value}}</span>
	</span>
</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		props: ['type', 'value'],
		computed: {
			option() {
				const {
					type,
					value,
					config,
				} = this;
				if (type && config && config.options && config.options[type] && config.options[type].length) {
					for (var i = 0; i < config.options[type].length; i++) {
						let option = config.options[type][i];
						if (value == option.value) {
							return option;
						}
					}
					return null;
				}
			}
		}
	}
</script>

<style>
</style>